import { IOption, Option } from 'shared/models/Option';
import { ISortOptionSchema as IGetOffersByPinSortOption } from 'shared/repositories/commercial-listing-map/entities/sort_option/SortOptionSchema';
import { ISortOptionSchema as IGetOffersSortOption } from 'shared/repositories/commercial-search-offers/entities/sort_option/SortOptionSchema';

export const getSortOptions = <T extends IGetOffersSortOption | IGetOffersByPinSortOption>(
  sortOptions: T[],
): IOption<string, T['value'] | 'default'>[] => {
  return [
    new Option('По умолчанию', 'default'),
    ...sortOptions.map(sortOption => new Option(sortOption.label, sortOption.value)),
  ];
};
